import { useState } from "react";

export const useLogoModal = () => {
  const [logoModalVisible, setLogoModalVisible] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState<string>("");
  const [selectedLogoProvider, setSelectedLogoProvider] = useState<string>("");

  const showLogoModal = (logoUrl: string, provider: string) => {
    setSelectedLogo(logoUrl);
    setSelectedLogoProvider(provider);
    setLogoModalVisible(true);
  };

  const hideLogoModal = () => {
    setLogoModalVisible(false);
    setSelectedLogo("");
    setSelectedLogoProvider("");
  };

  return {
    logoModalVisible,
    selectedLogo,
    selectedLogoProvider,
    showLogoModal,
    hideLogoModal,
  };
}; 